
<div mat-dialog-title class="mb-2">
    PRICING CALENDAR
    <button mat-icon-button class="close-button" matTooltip="Close" (click)="handleCancelClick()">
        <mat-icon class="close-icon" color="warn">close</mat-icon>
      </button>
</div>
<div mat-dialog-content class="grid grid-cols-1 h-full justify-between" style="grid-template-rows: auto 1fr auto;">
  <div class="flex items-center">
    <div class="mr-2">Select a lease term to see pricing availability</div>
    <div>
      <mat-form-field class="w-32">
        <select matNativeControl name="LeaseTerm" id="LeaseTerm" required [(ngModel)]="leaseTerm"
                #LeaseTerm="ngModel">
          <option value="" selected></option>
          <option *ngFor="let leaseTerm of leaseTermOptions" [value]="leaseTerm.value">
            {{leaseTerm.label}}
          </option>
        </select>
      </mat-form-field>
    </div>
  </div>
  <div *ngIf="renderCalendar" class="flex justify-center">
        <div class="relative h-full w-full p-8">
            <ngx-simple-calendar>
                <ng-template #day let-date="number" let-active="today" let-weekend="weekend"
                    let-datetime="startDateTime">
                  <div *ngIf="hasRentRates(datetime)" class="grid h-full cursor-pointer hover:bg-vivid-orange hover:text-white"
                    [class.active]="active" [class.weekend]="weekend" (click)="selectMoveInDate(datetime)"
                    [ngClass]="{'bg-vivid-orange text-white': (desiredMoveInDate) ? (desiredMoveInDate.getTime() === datetime.getTime()) : false}">
                        <div class="mt-2 ml-2">
                          {{date}}
                        </div>
                        <div class="mt-2 ml-2 mr-2 mb-1 self-end justify-self-end">
                          {{getRentRates(datetime) | currency : 'USD' : 'symbol' : '1.0-0' }}
                        </div>
                    </div>
                    <div *ngIf="!hasRentRates(datetime)" class="grid h-full" [class.active]="active"
                        [class.weekend]="weekend">
                        <div class="mt-2 ml-2">{{date}}</div>
                    </div>

                </ng-template>
            </ngx-simple-calendar>
        </div>
    </div>
</div>
<div mat-dialog-actions class="font-bold self-end mt-4">
        <div>
            Selected Move-In Date: {{desiredMoveInDate | date:'shortDate'}}
        </div>
        <div style="margin-left: auto;">
            <button mat-flat-button color="primary" [disabled]="(!desiredMoveInDate)" class="my-1 sm:text-base px-16" (click)="handleSelectClick()">SELECT</button>
        </div>
</div>
